module.exports = __webpack_public_path__ + "assets/media/devices.5c5c787d.mp4";